import React from 'react';
import Label from 'components/form/Label/Label';
import PIcon from 'components/personalization/PIcon';
import Icon from '@ant-design/icons';
import { FlexContainer } from 'components/Containers/FlexContainer/FlexContainer';
import { useEventHandler } from 'hook/event.hook';
import { getSimplifiedDate } from 'helpers/dateHelper';
import { CLICK } from 'externals/_tracking/types/eventTypes.constants';
import { SUBSCRIPTION_VERTICAL } from 'types/mrph.vertical.constants';

const RentReportingFeature = ({
  premiumImage,
  text,
  factor,
  premiumFeature,
  isPremiumUser,
  planNavName,
  isPulseUser,
  rentPaymentReport,
  isPremiumQualified,
  userInfo,
  history,
  planMetadata,
}) => {
  const eventHandler = useEventHandler();
  const isRentReportingUser =
    userInfo?.rentReporting?.status &&
    userInfo?.rentReporting?.status !== 'UNENROLLED';

  const handleLinkRedirect = () => {
    eventHandler(CLICK, {
      'Click Type': 'Navigation',
      'Nav Location': factor,
      'Page Position': 'Premium Features',
      Vertical: SUBSCRIPTION_VERTICAL,
    });

    if (isRentReportingUser) {
      rentPaymentReport.rentPaymentAuthenticate();
    } else {
      history.push('/rentPaymentReporting');
    }
  };

  if (
    isPremiumQualified(premiumFeature, isPremiumUser, planNavName, planMetadata)
  ) {
    const userHasPayments = isRentReportingUser
      ? rentPaymentReport?.paymentsResponse?.payments.length > 0
      : false;

    const latestRentPaymentDate = userHasPayments
      ? getSimplifiedDate(rentPaymentReport?.paymentsResponse?.payments[0].date)
      : null;

    return (
      <Label
        className="creditreportpagelink-container margL8"
        onClick={handleLinkRedirect}
      >
        <div className="premiumFeatureBox padT10 border-rad8px">
          <div
            className="premiumFeatureLink padB10"
            data-testid={text ? `${text}` : null}
          >
            <div className="premiumFeatureLink-left padL4 padR4">
              <div
                className="premiumFeatureLink-icon"
                data-testid={text ? `${text}-icon` : null}
              >
                <Icon className="menuButton outline" component={premiumImage} />
              </div>
            </div>
            <FlexContainer className="mCaption Caption textInfo">
              <div className="premiumFeatureLink-description">
                <Label
                  type="Subtitle-1"
                  data-testid={text ? `${text}-description` : null}
                >
                  {text}
                </Label>
              </div>
              {latestRentPaymentDate && (
                <Label>Last Payment {latestRentPaymentDate}</Label>
              )}
              <div
                className="premiumFeatureLink-right padR16"
                data-testid={text ? `${text}-back` : null}
              ></div>
            </FlexContainer>
            <PIcon
              icon={'right_pointing_arrow_icon'}
              className="arrowRightStyle"
            />
          </div>
        </div>
      </Label>
    );
  } else {
    return <></>;
  }
};

export default RentReportingFeature;
